import { IoIosLogOut } from 'react-icons/io';
import { useDispatch } from 'react-redux';

import { Creators as AuthActions } from '~/store/ducks/auth';

import { Container } from './styles';

const Logout = () => {
  const dispatch = useDispatch();

  const handleClickLogout = () => {
    dispatch(AuthActions.authLogout());
  };

  return (
    <Container type="button" onClick={handleClickLogout}>
      <IoIosLogOut />
    </Container>
  );
};

export default Logout;
